import React from 'react'
import PropTypes from 'prop-types'
import { InputGroup } from 'react-bootstrap'

import './style.scss'

const GenericFieldSet = props => {
  const BaseComponent = props.paramMap.baseComponent
  return (
    <InputGroup className="generic-fieldset fieldset" key={props.key}>
      {props.paramMap.valuePrefix && (
        <InputGroup.Text className="input-group__label">{props.paramMap.valuePrefix}</InputGroup.Text>
      )}
      <BaseComponent
        key={`paramMap-field-${props.paramMapIndex}`}
        dispatchAction={props.dispatchAction}
        options={props.paramMap.options}
        paramMap={props.paramMap}
      />
    </InputGroup>
  )
}

GenericFieldSet.propTypes = {
  key: PropTypes.string,
  dispatchAction: PropTypes.func,
  paramMap: PropTypes.object,
  paramMapIndex: PropTypes.number,
  options: PropTypes.array,
}

export default GenericFieldSet
